<i18n locale="en">
{
  "label": "Max"
}
</i18n>
<template>
  <span
    :class="['upsell-gate-badge', { 'upsell-gate-badge--dark': dark }]"
    data-testid="upsell-gate-badge"
  >
    <SparkleFilled :size="12" />
    {{ text ?? t('label') }}
  </span>
</template>

<script lang="ts" setup>
import { SparkleFilled } from '@owner/icons-vue/SparkleFilled'
import { useI18n } from 'vue-i18n'

withDefaults(
  defineProps<{
    /**
     * Dark-surface colorway for the upsell sheet (Figma node 428:25999); the
     * default light colorway (node 418:78813) is for the main UI.
     */
    dark?: boolean
    text?: string
  }>(),
  {
    dark: false,
    text: undefined,
  }
)

const { t } = useI18n()
</script>

<style lang="scss" scoped>
// Max gate badge for nav items, pickers, and the upsell sheet. Fixed palette
// from the tier-upgrades design — not yet in the Hermes tokens.
.upsell-gate-badge {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 500;
  line-height: 14.4px;
  text-transform: uppercase;
  color: #219de0;
  background-color: #e6f1f6;

  &--dark {
    position: relative;
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 12px;
    line-height: 16.8px;
    color: #56aedd;
    background-color: rgb(86 174 221 / 14%);

    // Pseudo-element so the color-dodge fill blends without dodging the text.
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      z-index: -1;
      border-radius: 8px;
      background-color: #16313f;
      mix-blend-mode: color-dodge;
    }
  }
}
</style>
